import * as React from "react";
import css from './ZapleczeHeaderBar.module.css'
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Breadcrumbs from "@mui/material/Breadcrumbs";
// @ts-ignore TODO ts-ignore
import {useNavigate, useLocation} from "react-router-dom";
import PropTypes from "prop-types";
// @ts-ignore TODO ts-ignore
import {FC, JSX, useEffect, useState} from "react";
// @ts-ignore TODO ts-ignore
import logo from "../images/logo.svg";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
// @ts-ignore TODO ts-ignore
import {Theme} from "../Components/styles/styles";
import {ThemeProvider} from "@mui/material";
import NativeSelect from "@mui/material/NativeSelect";
import {useAuth0, User} from "@auth0/auth0-react";
import {ZapleczeMenu} from "./ZapleczeMenu";


export interface ZapleczeHeaderBarProps {
    isProvider: boolean; // NOTE Kto to jest provider, po co i czy isAdmin nie wystarczy.
    isAdmin: boolean;
    user: User|undefined;
    contextList: string[];
    epidMap: any;
    selectedContext: string;
    setSelectedContext: (context: string) => void;
    drawerItemClickHandler: (id: number, item: string) => void;
    bgcolor?: string;
    fgcolor?: string;
}
const ZapleczeHeaderBar:FC<ZapleczeHeaderBarProps> = (inputProps):JSX.Element => {

    const props = {
        bgcolor: "#f2f3f5",
        fgcolor: "black",
        ...inputProps
    }

    console.log("ZapleczeHeaderBar props:", props);
    let menu = new ZapleczeMenu(props.isProvider);

    // @ts-ignore TODO ts-ignore
    const [clickedId, setClickedId] = React.useState(-1);

    // @ts-ignore TODO ts-ignore
    const handleMenuClick = (i) => {
        setClickedId(i);
        switch (i) {
            case ZapleczeMenu.WYLOGUJ:
                // @ts-ignore TODO ts-ignore
                props.drawerItemClickHandler(i, menu.list[i]);
                logout({
                    logoutParams: {returnTo: `${window.location.origin}`},
                });
                break
            default:
                // @ts-ignore TODO ts-ignore
                props.drawerItemClickHandler(i, menu.list[i]);
                break;
        }
    };

    const {logout} = useAuth0();
    // @ts-ignore TODO ts-ignore
    const [userContextList, setUserContenxtList] = React.useState(props.contextList);
    // @ts-ignore TODO ts-ignore
    const handleSelectChange = (event) => {
        console.log(event.target.value);
        // @ts-ignore TODO ts-ignore
        setSelectedContext(event.target.value);
    }
    // @ts-ignore TODO ts-ignore
    const [anchorEl, setAnchorEl] = useState(null);
    const navigate = useNavigate();

    // @ts-ignore TODO ts-ignore
    const handleClose = ():void => {
        setAnchorEl(null);
    };

    const [anchorElNav, setAnchorElNav] = React.useState(null);
    // @ts-ignore TODO ts-ignore
    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    // @ts-ignore TODO ts-ignore
    const searchedPlace = localStorage.getItem("searchedPlace");
    // @ts-ignore TODO ts-ignore
    const placeID = localStorage.getItem("placeID");

    // @ts-ignore TODO ts-ignore
    const sxMenuBtn = {
        my: 2,
        color: `${props.fgcolor}`,
        display: "block",
    }

    // @ts-ignore TODO ts-ignore
    const onClick = (event) => {
        console.log(event);
    }
    // @ts-ignore TODO ts-ignore
    const onLogoutClick = (event) => {
        logout({
            logoutParams: {returnTo: `${window.location.origin}`},
        });
    }

    const sxMenuWylogujBtn = {
        my: 2,

        backgroundColor: "#18a75c",
        borderRadius: 16,
        minWidth: 112,
        height: 44,
        color: "#fff",
        fontSize: 16,
        fontStyle: "normal",
        fontFamily: "Poppins",
        fontWeight: 900,
        lineHeight: 4.38,
        letterSpacing: 0.14,
        textTransform: "initial",
        "&:hover": {
            cursor: "pointer",
            color: "#363636",
            borderColor: "#363636",
        },
    }

    let pages;
    if (props.isProvider) {
        pages = [
            {index: menu.OBSLUGA_LEADOW,    name: menu.menu()[menu.OBSLUGA_LEADOW],   onClick: onClick,       sx: sxMenuBtn},
            {index: menu.MAPA_DOBRA,        name: menu.menu()[menu.MAPA_DOBRA],       onClick: onClick,       sx: sxMenuBtn},
            {index: menu.PROFIL_FIRMY,      name: menu.menu()[menu.PROFIL_FIRMY],     onClick: onClick,       sx: sxMenuBtn},
            {index: menu.WYLOGUJ,           name: menu.menu()[menu.WYLOGUJ],          onClick: onLogoutClick, sx: sxMenuWylogujBtn}
        ];
    } else {
        pages = [
            {index: menu.OBSLUGA_LEADOW,    name: menu.menu()[menu.OBSLUGA_LEADOW],   onClick: onClick,       sx: sxMenuBtn},
            {index: menu.MAPA_DOBRA,        name: menu.menu()[menu.MAPA_DOBRA],       onClick: onClick,       sx: sxMenuBtn},
            {index: menu.ADMIN,             name: menu.menu()[menu.ADMIN],            onClick: onClick,       sx: sxMenuBtn},
            {index: menu.WYLOGUJ,           name: menu.menu()[menu.WYLOGUJ],          onClick: onLogoutClick, sx: sxMenuWylogujBtn}
        ];
    }

    const drawSelectEpidOrAdmin = () => {
        return (
            <Box
                id="imageTitle"
            >
                <ThemeProvider theme={Theme}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-evenly",
                            mt: 5,
                            width: "250px"
                        }}
                    >
                        <Avatar
                            variant="circular"
                            sx={{
                                width: "2vw",
                                height: "2vw",
                            }}
                            alt="Logo"
                            src={props.user?.picture}
                        ></Avatar>

                        <Box>
                            <Box
                                sx={{mr: "16px",}}
                            >
                                {/*@ts-ignore TODO ts-ignore*/}
                                <Typography variant="bodyMediumBlack">
                                    {`${props.user?.name}`}
                                </Typography>

                            </Box>
                            <NativeSelect
                                defaultValue={userContextList[0]}
                                onChange={(e) => {
                                    const selectedKey = e.target.options[e.target.selectedIndex].text;
                                    props.setSelectedContext(selectedKey);
                                }}
                            >

                                {Object.entries(props.epidMap).map(([key, val]) => {
                                    return (
                                        // @ts-ignore TODO ts-ignore
                                        <option value={val} key={key}>
                                            {key}
                                        </option>
                                    )
                                })}


                            </NativeSelect>

                        </Box>

                    </Box>
                </ThemeProvider>
            </Box>

        );
    }

    return (

        <AppBar
            className={css.zapleczeHeaderBar}
            position="sticky"
            id="header-zaplecze"
            sx={{
                height: "76px",
                gridArea: "nav",
                width: "100vw",
                backgroundColor: `${props.bgcolor}`,
                color: `${props.fgcolor}`,
                position: 'fixed',
                pl: "32px",
                // pr: "32px",
            }}
        >

            <Toolbar disableGutters
                     sx={{
                         width: "100%",
                         justifyContent: "space-between"
                     }}
            >

                <Avatar alt="Logo"
                        src={logo}
                        sx={{
                            width: "200px",
                            height: "58px"
                        }}
                        variant="square"
                        onClick={() => {
                            navigate(`/`);
                        }}
                />

                <Typography
                    variant="h6"
                    noWrap
                    component="div"
                    sx={{
                        flexGrow: {md: "1", sm: "1"},
                        display: {
                            color: `${props.fgcolor}`,
                        },
                    }}
                >                </Typography>

                <Box
                    sx={{
                        height: "76px",
                        flexGrow: {
                            md: "1",
                            sm: "1"
                        },
                        display: {
                            xs: "flex",
                            md: "none",
                            sm: "flex"
                        },
                        justifyContent: "end",
                    }}
                >
                
                    <IconButton
                        size="large"
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={handleOpenNavMenu}
                        color="inherit"
                    >
                        <MenuIcon/>
                    </IconButton>

                    <Menu
                        id="menu-appbar"
                        anchorEl={anchorElNav}
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                        }}
                        open={Boolean(anchorElNav)}
                        onClose={():void => setAnchorElNav(null)}
                        sx={{
                            display: {
                                xs: "block",
                                md: "none",
                                sm: "block"
                            },
                        }}
                    >
                        {pages.map((page):JSX.Element => (
                            <MenuItem key={page.index} onClick={():void => {
                                setAnchorElNav(null)
                                handleMenuClick(page.index);
                            }}>
                                <Typography textAlign="center">{page.name}</Typography>
                            </MenuItem>
                        ))}
                    </Menu>
                </Box>

                <Box id="bigMenu">
                    <Box
                        sx={{
                            flexGrow: {md: "2", sm: "2"},
                            display: {xs: "none", md: "flex", sm: "none"},
                        }}
                    >
                        <Breadcrumbs separator="">
                            {pages.map((page):JSX.Element => (
                                <Button
                                    key={page.index}
                                    onClick={():void => {
                                        handleMenuClick(page.index);
                                    }}
                                    sx={page.sx}
                                >
                                    {page.name}
                                </Button>
                            ))}
                        </Breadcrumbs>

                    </Box>

                </Box>

                {drawSelectEpidOrAdmin()}

            </Toolbar>

        </AppBar>

    );
};

ZapleczeHeaderBar.propTypes = {
    pages: PropTypes.arrayOf(PropTypes.string),
    settings: PropTypes.arrayOf(PropTypes.string),
    bgcolor: PropTypes.string,
    btnbgcolor: PropTypes.string,
    fgcolor: PropTypes.string,
};

export default ZapleczeHeaderBar;
